import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useDeleteMutation, useLogoutMutation } from '../../app/config/redux/slices/api/userApiSlice';
import AlertMessage from './AlertMessage';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../app/config/redux/slices/authSlice';


const DeleteUser = () => {
    const [mobile, setMobile] = useState("");
    const [alert, setAlert] = useState(null);
    const [errors, setErrors] = useState({});

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const[deleteApiCall] = useDeleteMutation();

    const {userInfo} = useSelector((state) => state.auth);

    const deleteSubmitHandler = async (e) => {
        e.preventDefault();

        if (mobile.trim() !== userInfo.username) {
            setErrors({ mobile: ["Mobile number does not match your account."] });
            return;
        }

        try {
            const res = await deleteApiCall({
                token: userInfo.access_token
            }).unwrap();
            dispatch(logout());
            setAlert({ type: 'success', message: res.status });

            setTimeout(() => {
                setAlert(null); // Auto close after 3s
            }, 3000); 
            navigate('/');

        } catch (error) {
            setAlert({ type: 'danger', message: error?.data?.message || error.error });

            setTimeout(() => {
            setAlert(null); // Auto close after 3s
            }, 3000);
        }
    };

    return (
        <section className="account py-80">
        {alert && (
            <AlertMessage
            message={alert.message}
            type={alert.type}
            onClose={() => setAlert(null)}
            />
        )}

        

        <div className="container container-lg">
            <div className="row gy-4">
            <div className="col-xl">
                <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 h-100">
                    <h6 className="text-xl mb-32">Delete My Account</h6>
                    <form onSubmit={deleteSubmitHandler}>
                        <div className="mb-24">
                        <label
                            htmlFor="mobile"
                            className="text-neutral-900 text-lg mb-8 fw-medium"
                        >
                            Mobile Number <span className="text-danger">*</span>
                        </label>
                        <input
                            type="text"
                            className={`common-input ${errors.mobile ? "is-invalid" : ""}`}
                            id="mobile"
                            placeholder="Enter your mobile number to confirm you want to delete your account"
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                        />
                        {errors.mobile && (
                            <div className="invalid-feedback">{errors.mobile[0]}</div>
                        )}
                        </div>

                        <div className="mt-48">
                        <button
                            type="submit"
                            className="btn btn-main py-18 px-40"
                        >
                            Confirm
                        </button>
                        </div>
                    </form>
                </div>
            </div>
            </div>
        </div>
        </section>
    )
}

export default DeleteUser